import { render, staticRenderFns } from "./correct-icon.vue?vue&type=template&id=5ff9467f&scoped=true&"
import script from "./correct-icon.vue?vue&type=script&lang=ts&"
export * from "./correct-icon.vue?vue&type=script&lang=ts&"
import style0 from "./correct-icon.vue?vue&type=style&index=0&id=5ff9467f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff9467f",
  null
  
)

export default component.exports